import React from "react";
import { convertCommunityUnit, convertUnit, roundUpTo2Decimals } from "../utils";
import { CommunityUnits } from "../constants";
import { IoMdArrowDown, IoMdArrowUp } from "react-icons/io";
import cx from 'classnames';

const CustomOption = (props) => {
  const { data, innerRef, innerProps } = props;
  const vm = data.vm;
  const disabled = data.disabled;
  const minVRam = data.minVRam;
  const countryInfo = vm.label_onthetaedgecloud_com_country ? `${vm.label_onthetaedgecloud_com_country.replaceAll('_', ' ')}` : '';
  const provinceInfo = vm.label_onthetaedgecloud_com_province ? `${vm.label_onthetaedgecloud_com_province.replaceAll('_', ' ')}` : '';
  const regionInfo = countryInfo ? `, Location: ${provinceInfo ? `${provinceInfo}, ` : ''}${countryInfo}` : '';
  return (
    <div ref={innerRef} {...innerProps}
      className={cx('CNodesCustomOption', { 'CNodesCustomOption__disabled': disabled })}
      title={disabled && minVRam ? `This machine does not have the minimum vRAM for this model, ${minVRam}` : undefined}>
      <div style={{ display: 'flex', alignItems: "center", justifyContent: 'space-between' }}>
        <div style={{ fontSize: '18px' }}>{`${vm.gpu_allocate} x ${vm.label_nvidia_com_gpu_product} ${convertUnit(vm.label_nvidia_com_gpu_memory, 'mb', undefined, 0)}`}</div>
        <div style={{ fontSize: '18px' }}>${roundUpTo2Decimals(vm.label_onthetaedgecloud_com_price_hr / 10000)}/hour</div>
      </div>
      <div className="CNodesCustomOption__subtitle">
        {`CPU: ${vm.cpu_allocate} Cores, Memory: ${convertCommunityUnit(vm.memory_allocate, vm.memory_capacity, 'bytes', CommunityUnits, 0)}, Storage: ${convertCommunityUnit(vm.ephemeral_storage_allocate, vm.ephemeral_storage_capacity, 'bytes', CommunityUnits, 0)}`}
        <div className="CNodesCustomOption__speed-wrap">
          <IoMdArrowUp />{vm.label_onthetaedgecloud_com_upload_speed_mbps}Mbps
          <IoMdArrowDown />{vm.label_onthetaedgecloud_com_download_speed_mbps}Mbps
        </div>
      </div>
      <div className="CNodesCustomOption__subtitle">
        {`Max Cuda: ${vm.label_nvidia_com_cuda_runtime_major}.${vm.label_nvidia_com_cuda_runtime_minor}${regionInfo}`}
      </div>
      <div>{`ID: ${vm.vm_id}`}</div>
    </div>
  );
};

export default CustomOption;